import ModalComponent from 'components/Common/Modal';
import useTranscripts from 'api/hooks/useTranscripts';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { useState } from 'react';

const DeleteTranscriptModal = (props) => {
  const { isOpen, setIsOpen, deleteItemState, setTranscripts } = props;
  const { deleteItem: item, setDeleteItem } = deleteItemState;
  const [isLoading, setIsLoading] = useState(false);
  const { removeTranscript } = useTranscripts();

  const closeModal = () => {
    if (isLoading) return;
    setIsOpen(false);
  };

  return (
    <ModalComponent maxWidth={500} isOpen={isOpen} setIsOpen={closeModal} onAfterClose={() => setDeleteItem(null)}>
      <div className='px-lg-5 px-3 py-5 text-center'>
        <p className='title-h5-m mb-2'>
          Are you sure you want to {item?.finished ? 'delete' : 'cancel'} this transcript?
        </p>
        <div className='pt-3'>
          <button
            onClick={async () => {
              setIsLoading(true);
              try {
                const { status } = await removeTranscript({ id: item?.id });
                if (status === 200) {
                  setTranscripts((current) => current.filter((transcript) => transcript.id !== item?.id));
                  createNotification('success', 'Transcript cancelled successfully');
                  setIsOpen(false);
                }
              } catch (error) {
              } finally {
                setIsLoading(false);
              }
            }}
            className='general-button danger-button px-4 py-2 rounded-pill'
            disabled={isLoading}
          >
            {isLoading && <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />}
            {item?.finished ? 'Delete' : 'Cancel'} transcript
          </button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default DeleteTranscriptModal;
